import React from "react";
import { useTranslation } from "react-i18next";
import SectionIntro from "./SectionIntro";

// Real guest reviews from Google & Booking.com (verbatim, lightly trimmed).
const reviews = [
  {
    quote:
      "Tout parfait. Abdellah nous a très bien accueillis avec thé et amandes. Un gîte incroyable, un super endroit.",
    name: "Claudine",
    place: "France",
    source: "Google",
  },
  {
    quote:
      "Great view, kind and generous host. Lovely outdoor patio, and the area has restaurants and plenty of outdoor activities.",
    name: "Tiffany",
    place: "United States",
    source: "Booking.com",
  },
  {
    quote:
      "Un tagine succulent, une chambre magnifique et chauffée, et une vue de la terrasse sur les montagnes enneigées.",
    name: "Valérie",
    place: "France",
    source: "Google",
  },
  {
    quote:
      "Abdellah was a great host. He went above and beyond — he even washed my car by hand before I left. And he's an excellent cook.",
    name: "Abdelhadi",
    place: "Morocco",
    source: "Booking.com",
  },
  {
    quote:
      "Un hôte adorable qui nous a accueillis très chaleureusement. Abdou est un excellent cuisinier — des plats variés et délicieux, y compris végétariens.",
    name: "Nora",
    place: "Vietnam",
    source: "Google",
  },
  {
    quote:
      "A new place but already a must. Away from the crowded Ourika, with a spectacular view from the best room. Abdellah goes out of his way to make your stay a success.",
    name: "Guuz",
    place: "Netherlands",
    source: "Booking.com",
  },
];

const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <SectionIntro
          eyebrow={t("testimonials.eyebrow")}
          title={t("testimonials.title")}
          className="mb-6"
        />
        <p className="text-center eyebrow text-brass mb-14 md:mb-16">
          {t("testimonials.rating")}
        </p>
      </div>

      {/* Continuous marquee (duplicated list for a seamless loop; pauses on hover) */}
      <div className="marquee-viewport overflow-hidden">
        <div className="marquee-track flex gap-6 px-3">
          {[...reviews, ...reviews].map((r, i) => (
            <article
              key={i}
              aria-hidden={i >= reviews.length}
              className="w-[300px] sm:w-[340px] flex-shrink-0 bg-cream border border-ink/10 p-8 flex flex-col"
            >
              <div className="text-brass tracking-[0.3em] mb-5" aria-hidden="true">
                ★★★★★
              </div>
              <p className="font-serif text-lg text-ink leading-relaxed font-light italic flex-1">
                “{r.quote}”
              </p>
              <div className="mt-6 pt-5 border-t border-ink/10">
                <p className="text-ink font-medium">{r.name}</p>
                <p className="text-ink-muted text-sm">{r.place} · {r.source}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
